function attachJobFormValidation(form) {
  if (!form || form.dataset.validationAttached === "true") return;

  form.dataset.validationAttached = "true";

  var phoneInput = form.querySelector("input[name='job[contact_phone]']");

  phoneInput.addEventListener('input', () => {
    checkPhoneValidation(phoneInput);

    if (!phoneInput.checkValidity()) {
      phoneInput.classList.add('is-invalid');
      phoneInput.classList.remove('is-valid');
    } else {
      phoneInput.classList.remove('is-invalid');
      phoneInput.classList.add('is-valid');
    }
  });

  form.addEventListener('submit', function(event) {
    checkPhoneValidation(phoneInput);

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

      checkRadioValidity(form.querySelector("input[name='job[starting]']"));
      checkRadioValidity(form.querySelector("input[name='job[preferred_outcome]']"));
      toggleSuburbInvalidFeedback();

      $('.js-clear_field').attr('disabled', 'disabled');

      const firstInvalid = getFirstInvalidField(form);
      showValidationBanner(firstInvalid);
    }

    form.classList.add('was-validated');
  });
}

$(function () {
  var form = document.getElementById('jobForm');
  attachJobFormValidation(form);
});

function checkPhoneValidation(phoneInput) {
  var phone = phoneInput.value.trim();
  var phoneRegex = /^(?!1300|1800)(0[23478])\d{8}$/;

  var invalidFeedbackElement = phoneInput.closest('.form-group').querySelector('.invalid-feedback');

  if (phone === "") {
    phoneInput.setCustomValidity("This field is required");
    invalidFeedbackElement.textContent = "Enter a contact phone";
    invalidFeedbackElement.style.display = 'block';
  } else if (!phoneRegex.test(phone)) {
    phoneInput.setCustomValidity("Invalid phone number format");
    invalidFeedbackElement.textContent = "Enter a valid phone number (10 digits, no 1300 or 1800)";
    invalidFeedbackElement.style.display = 'block';
  } else {
    phoneInput.setCustomValidity("");
    invalidFeedbackElement.style.display = 'none';
  }
}

function checkRadioValidity(radioButton) {
  if (radioButton.checkValidity() === false) {
    radioButton.parentNode.parentNode.classList.add('group-invalid');
  } else {
    radioButton.parentNode.parentNode.classList.remove('group-invalid');
  }
}

function toggleSuburbInvalidFeedback() {
  const $input = $('#job_suburb_name');
  const $hidden = $('#job_suburb_id');

  if ($input[0].checkValidity()) {
    $input.siblings('.invalid-feedback').hide();
  } else {
    $input.siblings('.invalid-feedback').show();
  }

  if ($hidden[0].checkValidity()) {
    $hidden.siblings('.invalid-feedback').hide();
  } else {
    $hidden.siblings('.invalid-feedback').show();
  }
}

function getFirstInvalidField(form) {
  const fields = form.querySelectorAll('input, textarea, select');

  for (let field of fields) {
    if (field.offsetParent === null) continue;
    if (field.disabled) continue;

    if (!field.checkValidity()) {
      return field;
    }
  }
  return null;
}

function showValidationBanner(firstInvalidField) {
  const banner = document.getElementById('validationBanner');
  if (!banner) return;

  banner.classList.remove('d-none');
  banner.classList.add('d-flex');

  document.getElementById('scrollToErrorBtn').onclick = function () {
    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidField.focus();
    }
    banner.classList.add('d-none');
    banner.classList.remove('d-flex');
  };
}
